import { Component } from '@angular/core';
import { BaseComponent, ValidationHandlerService } from 'lib/Vestra.shared';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/services/api-services';

@Component({
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class HomeComponent extends BaseComponent {
    constructor(private authenticationService: AuthenticationService, protected override modalService: BsModalService, protected override spinnerService: NgxSpinnerService, protected override validationHandlerService: ValidationHandlerService) {
        super(spinnerService, modalService, validationHandlerService);
    }

    ngOnInit() {}

    public get isAdmin() {
        return this.authenticationService.isAdmin();
    }
}
